export default __webpack_public_path__ + "static/media/China.aff7e48e.svg";